import type { Keys } from '@/models/login';
import { DATA_VIEW_FILTER_KEY } from './constants';
import type { StudyModel } from '@/models';

export class LocalStorageUtils {
  static setStudyDetails = (study: StudyModel) => {
    localStorage.setItem('studyId', study.identifier);
    localStorage.setItem('studyTitle', study.title);
    if (study.flags) {
      localStorage.setItem('studyFlags', JSON.stringify(study.flags));
    }
  };

  static getStudyIdentifier = () => {
    return localStorage.getItem('studyId');
  };

  static getCurrentDataViewFilter = () => localStorage.getItem(DATA_VIEW_FILTER_KEY);

  static setDataViewFilter = (filter: string) => localStorage.setItem(DATA_VIEW_FILTER_KEY, filter);

  static logoutUser = () => {
    localStorage.removeItem('keys');
    localStorage.removeItem('studyId');
    localStorage.removeItem('studyTitle');
    localStorage.removeItem('studyFlags');
  };
  
  static storeUserKeys = (keys: Keys) => {
    localStorage.setItem('keys', JSON.stringify(keys));
  };

  static onLoginSuccess = () => {
    const now = new Date().toISOString();

    const previousLogin = localStorage.getItem('lastLogin');

    if (previousLogin) {
      localStorage.setItem('lastLoginDisplay', previousLogin);
    }

    localStorage.setItem('lastLogin', now);
  };

  static setUserName = (userName: string) => {
    const keys = this.getUserKeys();
    keys.name = userName;
    this.storeUserKeys(keys);
  };

  static setUserAvatar = (newAvatar: string) => {
    const keys = this.getUserKeys();
    keys.avatar = newAvatar;
    this.storeUserKeys(keys);
  };
  
  static getUserKeys = (): Keys => {
    const keys = localStorage.getItem('keys');
    return keys ? JSON.parse(keys) : null;
  };

  static getFirstName = () => {
    const keys = localStorage.getItem('keys');
    const keysJson: Keys = keys ? JSON.parse(keys) : undefined;
    return keysJson && keysJson.name ? keysJson.name.split(' ')[0] : '';
  };

  static getUserName = () => {
    const keys = localStorage.getItem('keys');
    const keysJson: Keys = keys ? JSON.parse(keys) : undefined;
    return keysJson && keysJson.name ? keysJson.name : '';
  };

  static getUserEmail = () => {
    const keys = localStorage.getItem('keys');
    const keysJson: Keys = keys ? JSON.parse(keys) : undefined;
    return keysJson && keysJson.email ? keysJson.email : '';
  };

  static getPart11Pin = () => {
    return localStorage.getItem('part11Pin');
  };

  static setPart11Pin = (pin: string) => {
    localStorage.setItem('part11Pin', pin);
  };
}
